<template>
  <main>
    <div class="all-loading" v-if="someLoading || closingStatus">
      <div class="message">
        <a-progress
            v-if="closingStatus"
            type="circle"
            :percent="closingPercent"
            :status="closingStatus == 'error' ? 'exception' : ''"
        />
        <template v-else>
          <loading-outlined v-if="loadingStatus === ''" style="font-size: 120px" spin/>
          <a-progress v-else-if="loadingStatus === 'success'" type="circle" :percent="100"/>
          <a-progress v-else-if="loadingStatus === 'error'" type="circle" :percent="100" status="exception"/>
          <div class="mTop20 text" v-if="loadingMessage !== ''">
            {{ loadingMessage }}
          </div>
          <div v-if="loadingNeedClose">
            <a-button @click="stopLoading()" class="mTop20" type="primary">Закрыть</a-button>
          </div>
        </template>
      </div>
    </div>

    <div class="crypto-page">
      <router-view v-if="$route.name === 'AuthView'"/>

      <template v-else>
        <a-affix :offset-top="top">
          <div class="crypto-header">
            <div class="left">
              <div class="shield-bg">
                <icon-crypto-logo/>
              </div>
              <div class="name">
                <div class="our-name">
                  Trade-Desk.o4biz.ru
                </div>
                <h1>Актуальные сделки</h1>
              </div>
            </div>

            <div class="right">
              <UserInfo v-if="auth.user"/>
              <a-button size="large" v-else @click="() => toAuth()">
                <icon-login/>
                Войти
              </a-button>
            </div>
          </div>
        </a-affix>

        <div class="crypto-content">
          <router-view/>
        </div>

        <div class="crypto-footer">
          <copyright/>

          <div class="description">
            Не является индивидуальной инвестиционной рекомендацией
          </div>
        </div>
      </template>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserInfo from "@/components/user/Info";
import webSocket from "@/mixins/webSocket";
import IconCryptoLogo from "@/components/icons/CryptoLogo";
import IconLogin from "@/components/icons/Login";
import Copyright from "@/components/Copyright";

export default {
  name: 'CryptoApp',
  components: { Copyright, IconLogin, IconCryptoLogo, UserInfo },
  mixins: [ webSocket ],
  data() {
    return {
      location: document.location
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth",
      closingStatus: "closingStatus",
      closingPercent: "closingPercent",
      loading: "loading",
      loadingMessage: "loadingMessage",
      loadingStatus: "loadingStatus",
      loadingNeedClose: "loadingNeedClose"
    }),

    authLoading: function () {
      return this.auth === false;
    },
    someLoading: function () {
      return this.loading === true;
    }
  },
  watch: {
    auth: {
      handler(newData, oldData) {
        const isNowLoggedIn = newData?.status === true && (!oldData || oldData.status === false);
        const isNowLoggedOut = oldData?.status === true && newData?.status === false;

        if (isNowLoggedIn) {
          // Пользователь успешно вошел в систему
          this.WSConnectionClose();
          this.WSConnect();
          this.handleWSConnectionOpen();
        }

        if (isNowLoggedOut) {
          this.WSConnectionClose();
          this.WSConnect();
          this.handleWSConnectionOpen();
        }
      },
      deep: true // Если auth — это сложный объект, отслеживаем изменения внутри него
    }
  },
  mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  created() {
    this.getAuth();
    this.WSConnect();
    this.handleWSConnectionOpen();
  },
  beforeUnmount() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    this.WSConnectionClose();
  },
  methods: {
    ...mapActions([
      "getAuth",
      'stopLoading',
      'WSConnect',
      'WSConnectionOpen',
      'WSConnectionClose'
    ]),

    handleVisibilityChange() {
      // Если пользователь вернулся во вкладку (или разблокировал телефон)
      if (document.visibilityState === "visible") {
        console.log("📱 Вкладка активна. Принудительно проверяем сокет...");

        // Вызываем глобальный экшен проверки связи из стора
        // Если сокет "умер" в фоне, эта цепочка поднимет его заново
        this.$store.dispatch('WSConnect');

        // savedAuthData у нас уже лежит в сторе, поэтому сокет сам переоткроется
        const savedData = this.$store.state.activeSubscriptions; // опционально для дебага
      }
    },

    handleWSConnectionOpen() {
      if (this.auth && this.auth.status === true && this.auth.user) {
        this.WSConnectionOpen({
          groups: this.auth.groups,
          idUser: this.auth.user.idUser,
          idBranch: this.auth.currentBranch
        });
      } else {
        // Если это гость — шлем пустой вызов (Vuex сам подставит гостевой uuid из кук)
        this.WSConnectionOpen({
          idBranch: this.auth.currentBranch
        });
      }

      this.addWSSubscription({ type: 'trades' });
    },

    toAuth() {
      if (this.$route.name !== 'AuthView') {
        this.$router.push({ name: 'AuthView' });
      }
    }
  }
}
</script>

<style lang="less">
@import "style/crypto";
</style>